angular.module('app.directives').directive('editClientSmallLink', () => ({
    restrict: 'EA',

    scope: {
        clientId: '<clientId',
    },

    templateUrl: '/directives/buttons/edit_client.html',
}));
